import { getGameId } from '@/common/store'
import request from './requets'



class SimulatorModel {

    getLanguage() {
        const l = sessionStorage.getItem('language') || 'en'
         // 如果是香港 台湾 传递语言为中文繁体
        if (l == 'hk' || l == 'tw') {
            return 'tw'
        }
        if (l == 'zh' || l == 'ch') {
            return 'zh'
        }
        return 'en'
        
        // // 如果是香港 台湾 传递语言为中文繁体
        // if (l == 'hk' || l == 'tw') {
        //     return 'tw'
        // }else if (l == 'zh' || l == 'ch') {
        //     return 'zh'
        // }
        // return l
    }

    getHeroes() {
        return request({
            url: '/simulator/heroes',
            method: 'get',
            data: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        })
    }

    getTeams() {
        return request({
            url: '/simulator/teams',
            method: 'get',
            data: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        })
    }

    getArtifacts() {
        return request({
            url: '/simulator/artifacts',
            method: 'get',
            data: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        })
    }

    getAll() {
        return request({
            url: '/simulator/all',
            method: 'get',
            params: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        }).then((res: any) => {
            const d =  res.data || {}
            if (d && d.links) {
                let l: any = {}
                d.links.forEach((fItem: any) => {
                    if (+fItem.link_quality > 30) {
                        if (!l[fItem.link_type]) {
                            l[fItem.link_type] = []
                        }
                        l[fItem.link_type].push(fItem)
                    }
                })
                d.links = l
            }

            if(d && d.heroes && d.teams) {
                d.teams = d.teams.map((mapItem: any) => {
                    mapItem.heroes = mapItem.heroes.map((hItem: string) => {
                        return d.heroes.find((fItem: any) => fItem.hero_id == hItem) || {}
                    })
                    mapItem.artifacts = mapItem.artifacts.map((mapItem: string) => {
                        return (d.artifacts || []).find((hItem: any) => hItem.artifact_id == mapItem) || {}
                    })
                    return mapItem
                })
            }
            if (d && d.artifacts) {
                d.artifacts = d.artifacts.sort((a: any,b: any) => {
                    return +a.rare >= +b.rare ? -1 : 1
                })

                
                let artLinks: any = {
                    '1': (d.links || {})['1'] || []
                }
                d.artifacts.forEach((aItem: any) => {

                    if (aItem.kind && aItem.kind != '0') {
                        if (!artLinks['9999']) {
                            artLinks['9999'] = []
                        }
                        if (artLinks['9999'].findIndex((fItem: any) => fItem.link_id == aItem.kind) < 0) {
                            artLinks['9999'].push({
                                link_id: aItem.kind,
                                link_type: '9999',
                                icon: aItem.kind_icon
                            })
                        }
                    }
                })
                d.artifact_links = artLinks
            }
            return d
        })
    }

     

}
export default new SimulatorModel()